// UI: Tabs
// Tabs
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../state/store.ts";
import { setActiveTab } from "../../../state/tab/tabSlice.ts";
export function Tabs() {
    const client = useSelector((state: RootState) => state.client.client);
    const default_configs = client ? JSON.parse(client.default_configs) : "";
    const tabs = [
        "Home", 
        "Profil", 
        "Betaling",
        "Avtaler", 
        "Historikk"];
    const activeTab = useSelector((state: RootState) => state.tab.activeTab);
    const dispatch = useDispatch();
    return (
        <div className="flex flex-wrap gap-2">
            {tabs.map((t) => (
                <button
                    key={t}
                    onClick={() => dispatch(setActiveTab(t))}
                    className={`rounded-full px-4 py-2 text-sm text-white ${activeTab === t ? "border-purple-600 bg-purple-600" : "border-purple-300 hover:border-purple-500"}`}
                >
                    {t}
                </button>
            ))}
        </div>
    );
}